import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/translation.json'
import es from './locales/es/translation.json'
import fr from './locales/fr/translation.json'
import { DEFAULT_LOCALE_CODE } from '@messenger/consts'

// Helper to get lang from query param
function getLangFromQuery(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  return params.get('lang')
}

const localStorageLang: string | null =
  typeof window !== 'undefined' ? localStorage.getItem('language') : null
const queryLang = getLangFromQuery()
const initialLang = queryLang || localStorageLang || DEFAULT_LOCALE_CODE

export const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
} as const

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: DEFAULT_LOCALE_CODE,
  interpolation: {
    escapeValue: false,
  },
})

// Listen for language changes and update localStorage
if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng: string) => {
    localStorage.setItem('language', lng)
  })
}

export type Language = keyof typeof resources
export default i18n
